import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { setListType } from '../../visual/visual.actions';

@Component({
  selector: 'nns-header-list-type-selector-mobile',
  template: `
    <nns-button
      *ngIf="visual.listType==='plates' && visual.theme==='day'"
      (click)="setListTypeList()"
      icon="list-color"
      class="icon transparent"
    ></nns-button>
    <nns-button
      *ngIf="visual.listType==='plates' && visual.theme==='night'"
      (click)="setListTypeList()"
      icon="list"
      class="icon transparent"
    ></nns-button>
    <nns-button
      *ngIf="visual.listType==='list' && visual.theme==='day'"
      (click)="setListTypePlates()"
      icon="plates-color"
      class="icon transparent"
    ></nns-button>
    <nns-button
      *ngIf="visual.listType==='list' && visual.theme==='night'"
      (click)="setListTypePlates()"
      icon="plates"
      class="icon transparent"
    ></nns-button>
  `
})

export class HeaderListTypeSelectorMobileComponent {
  @Input() visual;
  constructor(
    public _store: Store<IAppState>
  ) { }

  setListTypeList() {
    this.selectViewType('list');
  }

  setListTypePlates() {
    this.selectViewType('plates');
  }

  selectViewType(type) {
    this._store.dispatch(setListType(type));
  }
}
